import { ToolOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useStartCorrection } from 'hooks';

export const StartCorrection = () => {
  const [handleGetCorrection, { loading }] = useStartCorrection();

  return (
    <Button
      size='large'
      type='primary'
      icon={<ToolOutlined />}
      loading={loading}
      onClick={() => handleGetCorrection()}
      className='start-correction-btn'
    >
      <span className='start-correction-btn-text'>Start Correction</span>
    </Button>
  );
};
